function xgIconTips(plugin, textKey, isShow) {
  try {
    return ' <div class="xg-tips '.concat(isShow ? "hide" : " ", '" lang-key="').concat(plugin.i18nKeys[textKey], '">\n    ').concat(plugin.i18n[textKey], "\n    </div>");
  } catch (e) {
    return '<div class="xg-tips hide"></div>';
  }
}
export { xgIconTips };



//////////////////
// WEBPACK FOOTER
// ./node_modules/_xgplayer@3.0.5@xgplayer/es/plugins/common/iconTools.js
// module id = 9/1V
// module chunks = 137